import React from 'react';
import { Box, Container, Typography, Card, CardContent } from '@mui/material';
import Grid from '@mui/material/Grid'; // Changed from Grid2 to Grid
import LanguageIcon from '@mui/icons-material/Language';
import GroupsIcon from '@mui/icons-material/Groups';
import InnerPageBanner from '../components/InnerPageBanner';

const AboutUs = () => {
    return (
        <Box>
            <InnerPageBanner title="About Us" />

            <Container sx={{ my: 6, p: { xs: 4, md: 6 }, backgroundColor: '#f1f1f1' }}>
                <Grid container spacing={{ xs: 2.5, md: 4 }} alignItems="center">
                    <Grid size={{ xs: 12, md: 6 }}> {/* Changed from size to item with xs/md props */}
                        <Box sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 3,
                            maxWidth: 450,
                            mx: { xs: 'auto', md: 0 }
                        }}>
                            {/* Card 1 */}
                            <Card sx={{
                                boxShadow: '0px 15px 40px rgba(0,0,0,0.06)',
                                borderRadius: 2,
                                borderBottom: '4px solid #2ABD9C',
                                width: '100%',
                            }}>
                                <CardContent sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    gap: 3,
                                    py: 3,
                                    px: 4
                                }}>
                                    <Box sx={{
                                        width: 70,
                                        height: 70,
                                        borderRadius: '50%',
                                        bgcolor: '#f0f7f5',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}>
                                        <LanguageIcon sx={{ fontSize: 32, color: '#2ABD9C' }} />
                                    </Box>
                                    <Box>
                                        <Typography variant="h3" fontWeight="700" sx={{ lineHeight: 1.2, color: '#1A2B3C' }}>
                                            5240
                                        </Typography>
                                        <Typography variant="body1" sx={{ color: '#6B7A8D', fontWeight: 500 }}>
                                            Orders Delivered
                                        </Typography>
                                    </Box>
                                </CardContent>
                            </Card>

                            {/* Card 2 */}
                            <Card sx={{
                                boxShadow: '0px 15px 40px rgba(0,0,0,0.06)',
                                borderRadius: 2,
                                borderBottom: '4px solid #2ABD9C',
                                width: '100%',
                                alignSelf: { md: 'flex-end' },
                                ml: { md: 6 }
                            }}>
                                <CardContent sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    flexDirection: 'column',
                                    gap: 3,
                                    py: 3,
                                    px: 4
                                }}>
                                    <Box sx={{
                                        width: 70,
                                        height: 70,
                                        borderRadius: '50%',
                                        bgcolor: '#f0f7f5',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}>
                                        <GroupsIcon sx={{ fontSize: 32, color: '#2ABD9C' }} />
                                    </Box>
                                    <Box>
                                        <Typography variant="h3" fontWeight="700" sx={{ lineHeight: 1.2, color: '#1A2B3C' }}>
                                            2500+
                                        </Typography>
                                        <Typography variant="body1" sx={{ color: '#6B7A8D', fontWeight: 500, textAlign: 'center' }}>
                                            Clients
                                        </Typography>
                                    </Box>
                                </CardContent>
                            </Card>
                        </Box>
                    </Grid>

                    {/* Right Column: Content */}
                    <Grid size={{ xs: 12, md: 6 }}> {/* Changed from size to item with xs/md props */}
                        <Card sx={{
                            boxShadow: '0px 15px 40px rgba(0,0,0,0.06)',
                            borderRadius: 2,
                            width: '100%',
                            height: '100%',
                            bgcolor: 'white'
                        }}>
                            <CardContent sx={{ p: { xs: 4, md: 6 } }}>
                                <Box sx={{ maxWidth: 550 }}>
                                    <Typography
                                        variant="h4"
                                        sx={{
                                            fontWeight: 600,
                                            mb: 3,
                                            textAlign: 'center',
                                            color: 'black',
                                            fontSize: { xs: '1.5rem', md: '2rem' }
                                        }}
                                    >
                                        Welcome to 4MH Enterprises
                                    </Typography>

                                    <Box sx={{ width: 70, height: 3, bgcolor: '#2ABD9C', mb: 4 }} />

                                    <Typography
                                        variant="body1"
                                        sx={{
                                            color: '#4A5A6E',
                                            lineHeight: 1.9,
                                            fontSize: '1.1rem',
                                            mb: 2
                                        }}
                                    >
                                        One of the most prestigious and recognized manufacturers, exporters, supplier of diverse varieties of natural stones.
                                    </Typography>

                                    <Typography
                                        variant="body1"
                                        sx={{
                                            color: '#4A5A6E',
                                            lineHeight: 1.9,
                                            fontSize: '1.1rem'
                                        }}
                                    >
                                        Our hot products which we manufacture on a very large scale are as follows granite cobblestones, Kerbstone, paving slabs of pavers, Palisades, pillars, slabs, tiles, stone articles and pebble stones.
                                    </Typography>
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};

export default AboutUs;